module.exports = __webpack_public_path__ + "img/kemi.a63edf4a.jpg";